import React from 'react'
import { MainTitleMid, ParagrafMid } from '../Styled'
import { UdviklingsProcesUnder, UdvKortCon, UdvKort, UdvIkon, UdvPara } from './UdviklingSection.styled'

const UdviklingSection = ({ title, underTitle, lt1, pa1, ic1, lt2, pa2, ic2, lt3, pa3, ic3 }) => {
    return (
        <div>
            {
                title ? (
                    <div>
                        <MainTitleMid>{title}</MainTitleMid>
                        <ParagrafMid>
                            {underTitle}
                        </ParagrafMid>
                    </div>
                ) : null
            }
            <UdviklingsProcesUnder>
                <UdvKortCon>
                    <UdvKort>
                        <UdvIkon icon={ic1} />
                        <h2>{lt1}</h2>
                        <UdvPara>
                            {pa1}
                        </UdvPara>
                    </UdvKort>
                    <UdvKort>
                        <UdvIkon icon={ic2} />
                        <h2>{lt2}</h2>
                        <UdvPara>
                            {pa2}
                        </UdvPara>
                    </UdvKort>
                    <UdvKort>
                        <UdvIkon icon={ic3} />
                        <h2>{lt3}</h2>
                        <UdvPara>{pa3}</UdvPara>
                    </UdvKort>
                </UdvKortCon>
            </UdviklingsProcesUnder>
        </div>
    )
}

export default UdviklingSection